<div class="mainCategory-container" *ngIf="mainCategory">
    <div class="mainCategory-title">
        <a class="mainCategory" appclick
            [routerLink]="['/', translate.currentLang, 'category', mainCategory?.seo?.slug]">
            {{translateHelper.localize(mainCategory?.name)}}
            <span class="mobile:hidden">:</span>
        </a>
        <span class="mobile:hidden caption">{{translateHelper.localize(caption)}}</span>
    </div>
    <div class="row m-0">
        <div class="col-lg-2 p-0">
            <div class="mainCategory-image" style="background-image: url('{{image.url}}');">
                <div class="links">
                    <a appclick [routerLink]="['/', translate.currentLang, 'category', mainCategory?.seo?.slug]"
                        class="btn btn-primary">{{'view_all' | translate}}</a>
                    <!--                     <a appclick [routerLink]="['/', translate.currentLang, 'mainCategory', mainCategory?.seo?.slug, 'site', 'stores']" class="btn btn-primary">{{'view_vendors' | translate}}</a>
 -->
                </div>
            </div>
        </div>
        <div class="md:flex-col md:basis-0 w-full px-0 pt-lg-0 pt-3 md:ms-3">
            <div
                class="grid  auto-rows-fr grid-flow-row auto-cols-fr  desktop:grid-rows-2 desktop:grid-cols-3  tablet:grid-cols-3  mobile:grid-cols-1 gap-1 category-row">
                <ng-container *ngFor="let grid of element.catGrid;let i = index;">
                    <ng-container *ngIf="grid">
                        <div [class]="grid  + ' mobile:col-span-2'">
                            <div class="category-item">
                                <div class="image"
                                    style="background-image: url('{{categoriesCountedList[i].thumbnail?.url}}');">
                                </div>
                                <div class="details">
                                    <div class="info">
                                        <div class="title">
                                            <a appclick
                                                [routerLink]="['/', translate.currentLang, 'category', categoriesCountedList[i].seo?.slug]"
                                                class="title">
                                                {{translateHelper.localize(categoriesCountedList[i].name)}}
                                            </a>
                                        </div>
                                        <div class="subcategories-block">
                                            <ng-container
                                                *ngFor="let subcategory of categoriesCountedList[i].subCategories">
                                                <a appclick
                                                    [routerLink]="['/', translate.currentLang, 'category', subcategory.seo?.slug]"
                                                    class="subcategory">
                                                    {{translateHelper.localize(subcategory.name)}}
                                                </a>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="controls">
                                        <a appclick
                                            [routerLink]="['/', translate.currentLang, 'category', categoriesCountedList[i].seo?.slug]"
                                            class="btn btn-primary">{{'view_all' | translate}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </ng-container>
                <ng-container *ngFor="let grid of element.grid;let i = index">
                    <ng-container *ngIf="grid">
                        <div [class]="grid + ' mobile:col-span-2'">
                            <a *ngIf="element.banners[i].url && element.banners[i].url[translate.currentLang]"
                                [routerLink]="element.banners[i].url[translate.currentLang]">
                                <div class="category-item category-banner"
                                    style="background-image: url('{{element.banners[i][translate.currentLang]?.image?.url}}');">
                                </div>
                            </a>
                            <div *ngIf="!element.banners[i].url || !element.banners[i].url[translate.currentLang]"
                                class="category-item category-banner"
                                style="background-image: url('{{element.banners[i][translate.currentLang]?.image?.url}}');">
                            </div>

                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>